import React from 'react';
import { Container } from '@ui';
import { Body5 } from '@ui';
import { ResultContext } from '@/contexts/ResultContext';
import { CollapseButton } from '@ui/buttons/CollapseButton';
import styled from 'styled-components';

const ContextWrapper = styled.div``;
const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
`;
const Label = styled.div`
  padding-bottom: 8px;
`;

export const NewsSources = ({ top = 0 }) => {
  const { streamingNewsSources } = React.useContext(ResultContext);
  const [isCollapsed, setIsCollapsed] = React.useState(true);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  if (!streamingNewsSources) return null;

  return (
    <ContextWrapper>
      <Container top={top} bottom={8}>
        <Container row alignRight>
          <ButtonWrapper onClick={toggleCollapse}>
            <Container right={4} bottom={4}>
              <Label>
                <Body5 bold>News Sources</Body5>
              </Label>
            </Container>
            <CollapseButton isCollapsed={isCollapsed} setCollapsed={setIsCollapsed} />
          </ButtonWrapper>
        </Container>
        {/* <ResultOnly result={streamingNewsSources} allowLinks isComplete /> */}
      </Container>
    </ContextWrapper>
  );
};
